const preStudy = "https://forms.gle/UEVi8mUfzCExLP5NA";
const preTaskAIFutureWork = "https://forms.gle/3pxw7DWbJftcXfaSA";
const postTaskAIFutureWork = "https://forms.gle/WeP3QjnSTy3nY52i8";
const preTaskGlobalWarming = "https://forms.gle/zk3MddTFBEbjsfZ89";
const postTaskGlobalWarming = "https://forms.gle/ADiq1Buc6QHYzqSd6";
const postStudy = "https://forms.gle/tRdgsJmFDRv4uLkBA";

export enum TaskValue {
  Tutorial = 0,
  AIFutureWork = 1,
  GlobalWarming = 2,
  Demo = 3,
  Empty = 4,
}

// Key: <topic>-<platform>
export enum FlowType {
  BaselineTutorial = '0-1',
  SensecapeTutorial = '0-2',
  PrepareAIFutureWork = '1-p',
  BaselineAIFutureWork = '1-1',
  SensecapeAIFutureWork = '1-2',
  PrepareGlobalWarming = '2-p',
  BaselineGlobalWarming = '2-1',
  SensecapeGlobalWarming = '2-2',
}

interface StudyFlow {
  preTaskSurveyLink: string;
  preTaskFlow: FlowType;
  interfaceTutorial: FlowType;
  taskFlow: FlowType;
  postTaskSurveyLink: string;
}

export interface StudyAgenda {
  preStudySurveyLink: string;
  flow1: StudyFlow;
  flow2: StudyFlow;
  postStudySurveyLink: string;
}

const AIFutureWorkBaselineFlow: StudyFlow = {
  preTaskSurveyLink: preTaskAIFutureWork,
  preTaskFlow: FlowType.PrepareAIFutureWork,
  interfaceTutorial: FlowType.BaselineTutorial,
  taskFlow: FlowType.BaselineAIFutureWork,
  postTaskSurveyLink: postTaskAIFutureWork,
}

const AIFutureWorkSensecapeFlow: StudyFlow = {
  preTaskSurveyLink: preTaskAIFutureWork,
  preTaskFlow: FlowType.PrepareAIFutureWork,
  interfaceTutorial: FlowType.SensecapeTutorial,
  taskFlow: FlowType.SensecapeAIFutureWork,
  postTaskSurveyLink: postTaskAIFutureWork,
}

const GlobalWarmingBaselineFlow: StudyFlow = {
  preTaskSurveyLink: preTaskGlobalWarming,
  preTaskFlow: FlowType.PrepareGlobalWarming,
  interfaceTutorial: FlowType.BaselineTutorial,
  taskFlow: FlowType.BaselineGlobalWarming,
  postTaskSurveyLink: postTaskGlobalWarming,
}

const GlobalWarmingSensecapeFlow: StudyFlow = {
  preTaskSurveyLink: preTaskGlobalWarming,
  preTaskFlow: FlowType.PrepareGlobalWarming,
  interfaceTutorial: FlowType.SensecapeTutorial,
  taskFlow: FlowType.SensecapeGlobalWarming,
  postTaskSurveyLink: postTaskGlobalWarming,
}

export const taskByGroup: {[group: string]: StudyAgenda} = {
  'a': {
    preStudySurveyLink: preStudy,
    flow1: AIFutureWorkBaselineFlow,
    flow2: GlobalWarmingSensecapeFlow,
    postStudySurveyLink: postStudy,
  },
  'b': {
    preStudySurveyLink: preStudy,
    flow1: AIFutureWorkSensecapeFlow,
    flow2: GlobalWarmingBaselineFlow,
    postStudySurveyLink: postStudy,
  },
  'c': {
    preStudySurveyLink: preStudy,
    flow1: GlobalWarmingSensecapeFlow,
    flow2: AIFutureWorkBaselineFlow,
    postStudySurveyLink: postStudy,
  },
  'd': {
    preStudySurveyLink: preStudy,
    flow1: GlobalWarmingBaselineFlow,
    flow2: AIFutureWorkSensecapeFlow,
    postStudySurveyLink: postStudy,
  },
}